function pad(value) {
  return String(value).padStart(2, "0");
}

function getTimeParts(endDate) {
  const remainingMs = Math.max(0, endDate.getTime() - Date.now());
  const totalSeconds = Math.floor(remainingMs / 1000);

  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return {
    days: pad(days),
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
    isComplete: remainingMs === 0,
  };
}

function createSegment(value, label) {
  const segment = document.createElement("div");
  segment.style.display = "flex";
  segment.style.flexDirection = "column";
  segment.style.alignItems = "center";
  segment.style.gap = "0.5rem";

  const card = document.createElement("div");
  card.dataset.countdownValue = value;
  card.dataset.countdownLabel = label;
  card.textContent = value;
  card.style.display = "flex";
  card.style.alignItems = "center";
  card.style.justifyContent = "center";
  card.style.width = "40px";
  card.style.height = "40px";
  card.style.borderRadius = "0.5rem";
  card.style.backgroundColor = "transparent";
  card.style.color = "#102033";
  card.style.fontFamily = "'Doto', sans-serif";
  card.style.fontSize = "2rem";
  card.style.fontWeight = "900";
  card.style.lineHeight = "1";

  const caption = document.createElement("div");
  caption.textContent = label;
  caption.style.color = "#102033";
  caption.style.fontSize = "1rem";
  caption.style.fontWeight = "400";
  caption.style.lineHeight = "1";

  segment.append(card, caption);

  return segment;
}

function createDivider() {
  const divider = document.createElement("div");
  divider.textContent = ":";
  divider.setAttribute("aria-hidden", "true");
  divider.style.fontSize = "1.5rem";
  divider.style.fontWeight = "900";
  divider.style.lineHeight = "1";
  divider.style.color = "#062f56";
  divider.style.paddingBottom = "1.5rem";
  return divider;
}

function renderCountdown(element, parts) {
  element.innerHTML = "";
  element.style.display = "flex";
  element.style.justifyContent = "center";
  element.style.alignItems = "flex-start";
  element.style.gap = "0.5rem";

  const values = [
    ["D", parts.days],
    ["H", parts.hours],
    ["M", parts.minutes],
    ["S", parts.seconds],
  ];

  values.forEach(([label, value], index) => {
    element.appendChild(createSegment(value, label));

    if (index < values.length - 1) {
      element.appendChild(createDivider());
    }
  });
}

function startCountdown(element, endDate) {
  let intervalId = null;

  const update = () => {
    const parts = getTimeParts(endDate);
    renderCountdown(element, parts);

    if (parts.isComplete && intervalId !== null) {
      window.clearInterval(intervalId);
      element.removeAttribute("data-countdown-interval-id");
    }
  };

  update();

  intervalId = window.setInterval(update, 1000);
  element.dataset.countdownIntervalId = String(intervalId);
}

/**
 * Initialize countdown timers on the page.
 */
export function initializeCountdowns() {
  const countdownElements = document.querySelectorAll(
    "[data-countdown-end]:not([data-countdown-initialized])",
  );

  countdownElements.forEach((element) => {
    element.setAttribute("data-countdown-initialized", "true");

    const endDateString = element.getAttribute("data-countdown-end");

    if (!endDateString) {
      console.warn(
        "Countdown element missing data-countdown-end attribute",
        element,
      );
      return;
    }

    const endDate = new Date(endDateString);

    if (Number.isNaN(endDate.getTime())) {
      console.warn("Invalid countdown date:", endDateString);
      return;
    }

    try {
      startCountdown(element, endDate);
    } catch (error) {
      console.error("Error initializing countdown:", error, endDateString);
    }
  });
}
